module.exports = __webpack_public_path__ + "static/media/sheet2.9892fdde.svg";